var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1543,3.98438c-0.32506,0.01434 -0.62791,0.10902 -0.89453,0.2168c-0.24975,0.10046 -1.204,0.50974 -2.70703,1.1543c-1.50434,0.64512 -3.49626,1.50031 -5.62109,2.41406c-4.24968,1.8275 -9.02743,3.88464 -11.47461,4.9375c-0.09202,0.03958 -0.41311,0.14215 -0.75391,0.4082c-0.3408,0.26605 -0.70312,0.81735 -0.70312,1.43164c0,0.49534 0.23607,0.98744 0.5332,1.28125c0.29714,0.29381 0.61154,0.43894 0.88086,0.54883c0.97717,0.39871 4.00778,1.63891 4.58008,1.87305c0.20141,0.61698 1.29835,3.97253 1.55273,4.79492c0.16769,0.5427 0.32732,0.8826 0.53516,1.15234c0.10392,0.13487 0.22471,0.25307 0.37109,0.3457c0.05851,0.03702 0.12266,0.06554 0.1875,0.0918l0.00391,0.00195c0.01494,0.006 0.02782,0.01618 0.04297,0.02148c0.02858,0.01 0.0477,0.0112 0.08594,0.01953c0.15232,0.04919 0.30611,0.08008 0.44336,0.08008c0.58516,0 0.94336,-0.32227 0.94336,-0.32227l0.02149,-0.01562l3.00977,-2.60352l3.65039,3.45313c0.0514,0.07268 0.53074,0.73047 1.58789,0.73047c0.6277,0 1.12563,-0.31497 1.44531,-0.65039c0.31968,-0.33542 0.51885,-0.6878 0.60352,-1.13086v-0.00195c0.07919,-0.41867 3.44336,-17.68945 3.44336,-17.68945l-0.00586,0.02344c0.09848,-0.44951 0.12429,-0.86814 0.01563,-1.28125c-0.10867,-0.41311 -0.39499,-0.80864 -0.75,-1.02148c-0.35497,-0.2128 -0.70229,-0.27801 -1.02734,-0.26367zM24.9668,6.07422c-0.0048,0.02919 0.00359,0.01451 -0.00391,0.04883l-0.00195,0.01172l-0.00195,0.01172c0,0 -3.3225,17.04989 -3.44531,17.69922c0.00899,-0.04904 -0.0321,0.04846 -0.07422,0.10742c-0.05955,-0.04105 -0.18164,-0.09375 -0.18164,-0.09375l-0.01953,-0.02148l-4.98633,-4.7168l-3.52539,3.04688l1.04883,-4.19922c0,0 6.55617,-6.78664 6.95117,-7.18164c0.318,-0.316 0.38477,-0.42616 0.38477,-0.53516c0,-0.146 -0.07609,-0.25195 -0.24609,-0.25195c-0.153,0 -0.35875,0.14875 -0.46875,0.21875c-1.4331,0.91354 -7.72466,4.58039 -10.54492,6.2207c-0.44819,-0.18342 -3.5619,-1.45798 -4.61719,-1.88867c0.00799,-0.0035 0.00536,-0.00226 0.01367,-0.00586c2.44782,-1.05314 7.22358,-3.11026 11.47266,-4.9375c2.12454,-0.91362 4.11797,-1.76946 5.62109,-2.41406c1.47998,-0.63467 2.50833,-1.07147 2.625,-1.11914z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg_icon.ad5b2e952289c95d28728b166eb54659.svg";
export { ForwardRef as ReactComponent };